import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Moment from "moment";
import { DownloadShipDetails } from "../Actions/ClientDashboardAPI";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import i18n from "./DropdownLanguage/i18n";
class InactiveShipCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
    };
  }
  renderedit(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label style={{ padding: "0px 10px" }}>{this.props.t("PendingShipScreenContent.ViewShipDetails")}</label>
        </Popover.Content>
      </Popover>
    );
  }
  render() {
    const { arraylist, currentPage,pageSize, totalRecords, t } = this.props;
    return (
      <div className="pb-3">
        {this.renderCardData()}
        {totalRecords !== 0 ? (
          <Paginator
            first={currentPage}
            rows={pageSize}
            totalRecords={totalRecords}
            onPageChange={(e) => this.onPaginatorChange(e)}
          ></Paginator>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div class="container">
              <h6 className="resource-list-title no-item-card mb-0">
                !--{t("CommonText.NoItem")}--!
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }
  onPaginatorChange(event) {
    this.setState({
      first: event.first,
    });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1);
  }
  renderCardData = () => {
    const { showSidePane, arraylist, eyeclick, t } = this.props;
    const isArabic = i18n.language === 'arab'
    return arraylist.data && arraylist.data.length
      ? arraylist.data.map((item, index) => {
        return (
          <div
            className="card mb-2"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className={"col-sm-10 col-md-11 col-10 col-m-auto"}>
                    <div className="row px-3">
                      <div className="col-md-12 mb-1">
                        <h6 className="resource-list-title m-0">
                          {item.shipName}{" "}
                        </h6>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-6 mb-1" : "col-sm-4 col-md-2"
                        }
                      >
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong>{t("content.IMOno")} </strong>
                          <strong>:</strong>
                          <span className="italicFont ">{item.imoNo} </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-6 mb-1" : "col-sm-4 col-md-3"
                        }
                      >
                        <span>
                          <strong>{t("TopPaneContent.Flag")} : </strong>
                          <span className="italicFont ">{item.flag} </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-6 mb-1" : "col-sm-4 col-md-3"
                        }
                      >
                        <span>
                          <strong>{t("TopPaneContent.Class")} : </strong>
                          <span className="italicFont ">{item ? item?.class?.length === 0 ? " " : item?.class?.length > 1 ? item?.class?.map((item) => { return item }).join(',' + " ")
                            : item?.class?.map((i) => i) : ""} </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-6 mb-1" : "col-sm-4 col-md-2"
                        }
                      >
                        <span>
                          <strong>{t("ShipManagementContent.GRT")} : </strong>
                          <span className="italicFont ">{item.grt} </span>
                        </span>
                      </div>
                      <div
                        className={
                          showSidePane ? "col-sm-6 mb-1" : "col-sm-4 col-md-2"
                        }
                      >
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong>{t("ShipManagementContent.DeadWeight")} </strong>
                          <strong>:</strong>
                          <span className="italicFont ">
                            {item.deadWeight}{" "}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      "col-sm-2 col-md-1 col-2 col-m-auto text-right"
                    }
                  >
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 400 }}
                      overlay={this.renderedit()}
                    >
                      <i
                        className="fa fa-eye click"
                        onClick={() => eyeclick(item)}
                        aria-hidden="true"
                        style={{
                          color: " #1a3464",
                          fontSize: "1.8rem",
                          marginLeft: "-15px",
                        }}
                      ></i>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InactiveShipCard)));
